import cx from "classnames";
import { MonthPlanEntity } from "modules/finances/entities";
import { CreateFirst } from "modules/finances/widgets/month-plan-list/ui/create-first/create-first";
import Router from "next/router";
import pages from "pages/_router";
import React, { CSSProperties, useMemo } from "react";
import { api, MonthPlanCommonNextMonthPlanDto, MonthPlanSimpleDto } from "shared/api";
import { IListData, List } from "shared/ui";
import { getOpenMonth, nextMonthPlanDate } from "./lib";
import styles from "./month-plan-list.module.scss";
import { FinancialPlanningRow, MonthPlanNextEntity } from "./ui";

export interface IMonthPlanList extends IListData<MonthPlanSimpleDto> {
  companySlug: string;
  className?: string;
  style?: CSSProperties;
  htmlId?: string;
}

export const MonthPlanList = (props: IMonthPlanList) => {
  const nextDate = useMemo(() => nextMonthPlanDate(props.data), [props.data]);

  const monthPlanNext = api.monthPlan.useMonthPlanCommonNextMonthPlan(
    props.companySlug,
    nextDate?.year!,
    nextDate?.month!
  );

  const currentFPResp = api.financialPlanCommon.useFinancialPlanCommonLastDraftOrOnApproval(props.companySlug);
  const currentFP = currentFPResp.data?.financialPlan;

  const openMonth = useMemo(() => getOpenMonth(props.data), [props.data]);

  const onCreate = async (data: MonthPlanCommonNextMonthPlanDto) => {
    const draft = await api.monthPlan.monthPlanCreate(props.companySlug, data);
    await Router.push(pages.company(props.companySlug).finances.yearMonth(draft.year, draft.month).href);
  };

  if (props.data?.length === 0) {
    return (
      <div className={cx(styles.month_plan_list, props.className)} style={props.style} id={props.htmlId}>
        <CreateFirst onCreate={onCreate} companySlug={props.companySlug} />
      </div>
    );
  }

  return (
    <List
      {...props}
      className={cx(styles.month_plan_list, props.className)}
      header={
        <>
          {monthPlanNext.data && <MonthPlanNextEntity data={monthPlanNext.data} onCreate={onCreate} />}
          {!openMonth && !!props.data?.length && (
            <FinancialPlanningRow companySlug={props.companySlug} monthPlanList={props.data!} />
          )}
        </>
      }
      renderItem={(it) => {
        const open = openMonth?.id === it.id;

        return (
          <>
            <MonthPlanEntity data={it} companySlug={props.companySlug} currentFP={currentFP} initialOpen={open} />
            {open && <FinancialPlanningRow companySlug={props.companySlug} monthPlanList={props.data!} />}
          </>
        );
      }}
    />
  );
};

MonthPlanList.defaultProps = {};
